var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',{attrs:{"theme":_vm.getTheme(),"label":_vm.getLabel(),"icon":_vm.getIcon()},on:{"onclick":function($event){return _vm.$emit('onclick')}}})}
var staticRenderFns = []

export { render, staticRenderFns }